import React from 'react'
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom'

// components
import Layout from './Layout'

// pages
import Error from '../pages/error'
import Login from '../pages/login'

// context
import { useUserState } from '../contexts/UserContext'
import { AppStateProvider } from '../contexts/AppStateContext'
import { ClientProvider } from '../contexts/ClientContext'

export default function App (props) {
  // global
  const { accessToken } = useUserState()

  const urlParams = new URLSearchParams(window.location.search)
  const token = urlParams.get('access_token')
  const expiry = urlParams.get('expires_in')
  const stateCode = urlParams.get('state')

  return (
    <BrowserRouter>
      <AppStateProvider>
        <ClientProvider>
          <Switch>
            <Route exact path="/" render={() => <Redirect to="/app/dashboard" />} />
            <Route exact path="/app" render={() => <Redirect to="/app/dashboard" />} />
            <PrivateRoute path="/app" component={Layout} />
            <PublicRoute path="/login" component={() => <Login token={token} expiry={expiry} stateCode={stateCode} />} />
            <Route component={Error} />
          </Switch>
        </ClientProvider>
      </AppStateProvider>
    </BrowserRouter>
  )

  // #######################################################################

  function PrivateRoute ({ component, ...rest }) {
    return (
      <Route
        {...rest}
        render={props =>
          accessToken ? (
            React.createElement(component, props)
          ) : (
            <Redirect
              to={{
                pathname: '/login',
                state: {
                  from: props.location
                }
              }}
            />
          )
        }
      />
    )
  }

  function PublicRoute ({ component, ...rest }) {
    return (
      <Route
        {...rest}
        render={props =>
          !token && accessToken ? (
            <Redirect
              to={{
                pathname: '/'
              }}
            />
          ) : (
            React.createElement(component, props)
          )
        }
      />
    )
  }
}
